import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/disabled-form-element/Query.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Button/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Form/style.module.css");
